// Mirrors tva-api constants/savedSearch.js — keep in sync.
export const SAVED_SEARCH_NAME_MAX_LENGTH = 60;
